import { render } from "./InputTimeComponent.vue?vue&type=template&id=3430214f"
import script from "./InputTimeComponent.vue?vue&type=script&lang=js"
export * from "./InputTimeComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__